import type { NavAction } from '@adflow/frontend/util-router';
import { joinPaths } from '@adflow/shared/util-route-schema';

const gmbTemplatesPath = '/google-my-business/templates';

export const goToAddGMBTemplate: NavAction = (location) => {
	const {
		openRows: _openRows,
		section: _section,
		...restQuery
	} = location.parsedSearch || {};
	return {
		...(location.pathname.startsWith(gmbTemplatesPath) ? location : {}),
		pathname: joinPaths(gmbTemplatesPath, 'add'),
		search: restQuery,
	};
};

export function goToEditGMBTemplate(templateId: number): NavAction {
	return (location) => {
		const {
			openRows: _openRows,
			section: _section,
			...restQuery
		} = location.parsedSearch || {};
		return {
			...(location.pathname.startsWith(gmbTemplatesPath) ? location : {}),
			pathname: joinPaths(gmbTemplatesPath, `${templateId}`),
			search: { ...restQuery, openRows: templateId },
		};
	};
}

export function goToGMBTemplateHistory(templateId: number): NavAction {
	return (location) => {
		const {
			openRows: _openRows,
			section: _section,
			...restQuery
		} = location.parsedSearch || {};
		return {
			...(location.pathname.startsWith(gmbTemplatesPath) ? location : {}),
			pathname: joinPaths(gmbTemplatesPath, `${templateId}`),
			search: { ...restQuery, openRows: templateId, section: 'history' },
		};
	};
}

export const goToGMBTemplatesList: NavAction = (location) => {
	const { openRows: _openRows, ...restQuery } = location.parsedSearch || {};
	return {
		...(location.pathname.startsWith(gmbTemplatesPath) ? location : {}),
		pathname: gmbTemplatesPath,
		search: restQuery,
	};
};
